import common from './common';
import ability from './ability';
import weixin from './weixin';
import role from './role';
import account from './account';
import miniProgram from './mini-program';

export default {
  ...common,
  ...account,
  ...role,
  ...ability,
  ...weixin,
  ...miniProgram,
};
